module.exports = true;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.library.js
 **/